if (!customElements.get('card-gift')) {
  customElements.define('card-gift', class CardGift extends HTMLElement {
    connectedCallback() {
      // Find the closest parent with class "mega-menu__item"
      this.parentItem = this.closest('.mega-menu__item');
      if (!this.parentItem) return;

      // Bind the check function
      this.boundCheckViewportPosition = this.checkViewportPosition.bind(this);

      // Throttle function (fallback if global throttle is not available)
      const throttleFallback = (fn, wait) => {
        let t = false;
        return function() {
          if (!t) {
            fn.apply(this, arguments);
            t = true;
            setTimeout(() => { t = false; }, wait);
          }
        };
      };

      // Use global throttle if available, otherwise use fallback
      this.throttledCheck = typeof throttle === 'function' 
        ? throttle(this.boundCheckViewportPosition, 100)
        : throttleFallback(this.boundCheckViewportPosition, 100);

      // Create bound handlers for cleanup
      this.handleResize = this.throttledCheck;
      this.handleScroll = this.throttledCheck;

      // Initial check
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.boundCheckViewportPosition);
      } else {
        this.checkViewportPosition();
      }

      // Check on resize and scroll
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('scroll', this.handleScroll, true);

      // Re-initialize on theme editor section load
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', () => {
          setTimeout(() => this.checkViewportPosition(), 100);
        });
      }
    }

    checkViewportPosition() {
      if (!this.parentItem) return;

      try {
        const rect = this.getBoundingClientRect();
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        
        const goesOutsideLeft = rect.left < 0;
        const goesOutsideRight = rect.right > viewportWidth;
        const isOutsideViewport = goesOutsideLeft || goesOutsideRight;
        
        if (isOutsideViewport) {
          this.parentItem.classList.add('mega-menu__item--centered');
        } else {
          this.parentItem.classList.remove('mega-menu__item--centered');
        }
      } catch (e) {
        // Silently fail if element is no longer in DOM
      }
    }

    disconnectedCallback() {
      // Clean up event listeners when element is removed
      if (this.handleResize) {
        window.removeEventListener('resize', this.handleResize);
      }
      if (this.handleScroll) {
        window.removeEventListener('scroll', this.handleScroll, true);
      }
      if (this.boundCheckViewportPosition && document.readyState === 'loading') {
        document.removeEventListener('DOMContentLoaded', this.boundCheckViewportPosition);
      }
    }
  });
}

